var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8 5H30.8V5.00004C35.1605 8.35208 38 13.8217 38 20C38 26.1783 35.1605 31.6479 30.8 35V35L30.8 35L28.8 35L9.20003 35C4.83951 31.648 2.00003 26.1783 2.00003 20C2.00003 13.8217 4.83951 8.35204 9.20003 5H28.8H30.8ZM9.90314 7H30.0969C33.6708 9.99866 36 14.6891 36 20C36 25.3109 33.6708 30.0013 30.0969 33H9.90314C6.32922 30.0013 4.00003 25.3109 4.00003 20C4.00003 14.6891 6.32922 9.99866 9.90314 7ZM12 13H13V19H12V13ZM10 11H12H13H15V13V19V21H13H12H10V19V13V11ZM28 13H27V19H28V13ZM27 11H25V13V19V21H27H28H30V19V13V11H28H27ZM22 28V29H18V28C18 26.8954 18.8954 26 20 26C21.1046 26 22 26.8954 22 28ZM16 28C16 25.7909 17.7909 24 20 24C22.2091 24 24 25.7909 24 28V29V31H22H18H16V29V28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticB);
export default __webpack_public_path__ + "static/media/DOMESTIC_B.1331b7d0b31177cf478a09c8122175a7.svg";
export { ForwardRef as ReactComponent };